// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Machine.css - Simple & Clean Style */

/* BODY */
body { 
  margin: 0;
  padding: 0;
  font-family: "Segoe UI", "Arial", sans-serif;
  color: #ffffff;
  background: linear-gradient(135deg, #0a1929 0%, #1a2332 100%);
  min-height: 100vh;
}

.no-clients {
  text-align: center;
  font-size: 20px;
  margin-top: 60px;
  color: #64b5f6;
  padding: 20px;
}

/* ==================== MACHINE TABLE ==================== */
.machine-table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  background: #1a2332;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
}

.machine-table thead tr {
  background: #0d1b2a;
  color: #ffffff;
  text-align: left;
  font-weight: 600;
}

.machine-table thead th {
  padding: 16px 12px;
  border-bottom: 2px solid #2c3e50;
  border-right: 1px solid #2c3e50;
  color: #ffffff;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: background 0.2s;
}

.machine-table thead th:last-child {
  border-right: none;
}

.machine-table thead th:hover {
  background: #15263a;
}

.machine-table tbody td {
  padding: 14px 12px;
  border-bottom: 1px solid #2c3e50;
  border-right: 1px solid #2c3e50;
  color: #ffffff;
  font-size: 14px;
}

.machine-table tbody td:last-child {
  border-right: none;
}

.machine-row {
  background: #1a2332;
  transition: all 0.2s ease;
}

.machine-row:hover {
  background: #243447;
  transform: scale(1.01);
  box-shadow: 0 2px 8px rgba(100, 181, 246, 0.2);
}

/* Các giá trị realtime màu vàng */
.realtime-value {
  color: #ffd700 !important;
}

.realtime-value span {
  color: #ffd700;
}

/* ==================== BUTTONS ==================== */
.btn {
  padding: 8px 14px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  margin: 0 4px;
  transition: all 0.2s;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.btn-edit {
  background: #2196f3;
  color: white;
}

.btn-edit:hover {
  background: #1976d2;
  transform: translateY(-1px);
}

.btn-save {
  background: #4caf50;
  color: white;
}

.btn-save:hover {
  background: #388e3c;
  transform: translateY(-1px);
}

.btn-delete {
  background: #f44336;
  color: white;
}

.btn-delete:hover {
  background: #d32f2f;
  transform: translateY(-1px);
}

.btn-cancel {
  background: #757575;
  color: white;
}

.btn-cancel:hover {
  background: #616161;
  transform: translateY(-1px);
}

/* ==================== CIRCULAR PROGRESS ==================== */
.circular-progress {
  display: inline-block;
  vertical-align: middle;
}

.circular-progress text {
  fill: #ffffff;
  font-family: "Segoe UI", Arial, sans-serif;
  font-weight: 600;
}

/* ==================== INPUTS ==================== */
.machine-table input {
  width: 90%;
  padding: 6px 10px;
  border: 1px solid #2c3e50;
  border-radius: 4px;
  background: #0d1b2a;
  color: #ffffff;
  font-size: 14px;
}

.machine-table input:focus {
  outline: none;
  border-color: #2196f3;
  background: #15263a;
}

/* ==================== LOGIN ==================== */
.login-container {
  width: 360px;
  margin: 100px auto;
  padding: 40px;
  background: #1a2332;
  border-radius: 8px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
}

.login-container h2 {
  margin: 0 0 30px 0;
  font-size: 28px;
  color: #ffffff;
  text-align: center;
  font-weight: 600;
}

.login-container input {
  display: block;
  width: 100%;
  margin: 16px 0;
  padding: 12px 16px;
  font-size: 16px;
  border-radius: 4px;
  border: 1px solid #2c3e50;
  background: #0d1b2a;
  color: #ffffff;
  box-sizing: border-box;
}

.login-container input:focus {
  outline: none;
  border-color: #2196f3;
}

.login-container input::placeholder {
  color: #7a8a99;
}

.login-container button {
  width: 100%;
  padding: 12px 0;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-radius: 4px;
  border: none;
  background: #2196f3;
  color: white;
  cursor: pointer;
  margin-top: 20px;
  transition: all 0.2s;
}

.login-container button:hover {
  background: #1976d2;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(33, 150, 243, 0.3);
}

/* ==================== LOADER ==================== */
.loader-fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #0a1929;
  z-index: 9999;
}

.loader-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
  background: #1a2332;
  border-radius: 8px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
}

.neon-spinner {
  width: 80px;
  height: 80px;
  border: 4px solid #2c3e50;
  border-top: 4px solid #2196f3;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loader-text {
  margin-top: 24px;
  color: #ffffff;
  font-size: 20px;
  font-weight: 600;
}

/* ==================== FILTER POPUP ==================== */
.filter-popup {
  position: absolute;
  z-index: 2000;
  background: #1a2332;
  border: 1px solid #2c3e50;
  border-radius: 4px;
  padding: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.filter-popup input,
.filter-popup select {
  width: 220px;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid #2c3e50;
  background: #0d1b2a;
  color: #ffffff;
  font-size: 14px;
  outline: none;
}

.filter-popup input:focus,
.filter-popup select:focus {
  border-color: #2196f3;
}

.filter-popup input::placeholder {
  color: #7a8a99;
}

/* ==================== IP ADDRESS LIST ==================== */
.ip-address-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ip-address-item {
  display: flex;
  gap: 8px;
  font-size: 13px;
}

.interface-name {
  color: #64b5f6;
  font-weight: 600;
  min-width: 80px;
}

.ip-value {
  color: #ffffff;
  font-family: 'Courier New', monospace;
}

.ip-address-list:has(.ip-address-item:only-child) {
  flex-direction: row;
}

/* ==================== PORTS POPUP ==================== */
.ports-popup-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000;
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.ports-popup {
  background: #1a2332;
  border-radius: 8px;
  padding: 0;
  max-width: 900px;
  width: 90%;
  max-height: 80vh;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  animation: slideIn 0.3s ease-out;
  display: flex;
  flex-direction: column;
}

@keyframes slideIn {
  from {
    transform: translateY(-30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.ports-popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #2c3e50;
  background: #0d1b2a;
  border-radius: 8px 8px 0 0;
}

.ports-popup-header h3 {
  margin: 0;
  font-size: 20px;
  color: #ffffff;
  font-weight: 600;
}

.close-btn {
  background: transparent;
  border: none;
  color: #ffffff;
  font-size: 28px;
  width: 36px;
  height: 36px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  line-height: 1;
  padding: 0;
}

.close-btn:hover {
  background: #f44336;
  transform: scale(1.1);
}

.ports-loading,
.no-ports {
  text-align: center;
  padding: 40px;
  font-size: 16px;
  color: #7a8a99;
}

.ports-table-wrapper {
  overflow-y: auto;
  max-height: calc(80vh - 80px);
}

.ports-table {
  width: 100%;
  border-collapse: collapse;
}

.ports-table thead {
  position: sticky;
  top: 0;
  background: #0d1b2a;
  z-index: 10;
}

.ports-table thead th {
  padding: 14px 16px;
  text-align: left;
  color: #ffffff;
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #2c3e50;
  border-right: 1px solid #2c3e50;
}

.ports-table thead th:last-child {
  border-right: none;
}

.ports-table tbody tr {
  background: #1a2332;
  transition: background 0.2s;
}

.ports-table tbody tr:hover {
  background: #243447;
}

.ports-table tbody td {
  padding: 12px 16px;
  border-bottom: 1px solid #2c3e50;
  border-right: 1px solid #2c3e50;
  color: #ffffff;
  font-size: 14px;
}

.ports-table tbody td:last-child {
  border-right: none;
}

.port-number {
  font-weight: 600;
  color: #ffd700;
  font-family: 'Courier New', monospace;
}

.process-name {
  color: #4caf50;
  font-weight: 500;
}

/* ==================== SCROLLBAR ==================== */
.ports-table-wrapper::-webkit-scrollbar {
  width: 10px;
}

.ports-table-wrapper::-webkit-scrollbar-track {
  background: #0d1b2a;
}

.ports-table-wrapper::-webkit-scrollbar-thumb {
  background: #2c3e50;
  border-radius: 5px;
}

.ports-table-wrapper::-webkit-scrollbar-thumb:hover {
  background: #3d5266;
}

/* ==================== DISK PROGRESS ==================== */
.disk-progress-column {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.disk-progress-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.disk-progress-item span {
  font-size: 12px;
  min-width: 140px;
}

/* ==================== ACTION BUTTONS ==================== */
.action-buttons {
  white-space: nowrap;
  padding: 8px 4px !important;
}

.action-buttons .btn {
  display: block;
  width: 100%;
  margin: 4px 0;
  padding: 8px 12px;
  text-align: center;
}

/* ==================== RESPONSIVE ==================== */
@media (max-width: 768px) {
  .machine-table {
    font-size: 12px;
  }
  
  .machine-table thead th,
  .machine-table tbody td {
    padding: 10px 8px;
  }
  
  .ports-popup {
    width: 95%;
  }
  
  .btn {
    padding: 6px 10px;
    font-size: 11px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Machine.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC,SAAS;AACT;EACE,SAAS;EACT,UAAU;EACV,4CAA4C;EAC5C,cAAc;EACd,6DAA6D;EAC7D,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA,4DAA4D;AAC5D;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,+BAA+B;EAC/B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA,sDAAsD;AACtD;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,gEAAgE;AAChE;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;EACE,UAAU;EACV,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,qDAAqD;AACrD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0DAA0D;AAC1D;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,yCAAyC;EACzC,gCAAgC;EAChC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,+BAA+B;EAC/B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,wDAAwD;AACxD;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,yDAAyD;AACzD;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":["/* Machine.css - Simple & Clean Style */\n\n/* BODY */\nbody { \n  margin: 0;\n  padding: 0;\n  font-family: \"Segoe UI\", \"Arial\", sans-serif;\n  color: #ffffff;\n  background: linear-gradient(135deg, #0a1929 0%, #1a2332 100%);\n  min-height: 100vh;\n}\n\n.no-clients {\n  text-align: center;\n  font-size: 20px;\n  margin-top: 60px;\n  color: #64b5f6;\n  padding: 20px;\n}\n\n/* ==================== MACHINE TABLE ==================== */\n.machine-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 20px 0;\n  background: #1a2332;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n}\n\n.machine-table thead tr {\n  background: #0d1b2a;\n  color: #ffffff;\n  text-align: left;\n  font-weight: 600;\n}\n\n.machine-table thead th {\n  padding: 16px 12px;\n  border-bottom: 2px solid #2c3e50;\n  border-right: 1px solid #2c3e50;\n  color: #ffffff;\n  font-size: 14px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.machine-table thead th:last-child {\n  border-right: none;\n}\n\n.machine-table thead th:hover {\n  background: #15263a;\n}\n\n.machine-table tbody td {\n  padding: 14px 12px;\n  border-bottom: 1px solid #2c3e50;\n  border-right: 1px solid #2c3e50;\n  color: #ffffff;\n  font-size: 14px;\n}\n\n.machine-table tbody td:last-child {\n  border-right: none;\n}\n\n.machine-row {\n  background: #1a2332;\n  transition: all 0.2s ease;\n}\n\n.machine-row:hover {\n  background: #243447;\n  transform: scale(1.01);\n  box-shadow: 0 2px 8px rgba(100, 181, 246, 0.2);\n}\n\n/* Các giá trị realtime màu vàng */\n.realtime-value {\n  color: #ffd700 !important;\n}\n\n.realtime-value span {\n  color: #ffd700;\n}\n\n/* ==================== BUTTONS ==================== */\n.btn {\n  padding: 8px 14px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  margin: 0 4px;\n  transition: all 0.2s;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.btn-edit {\n  background: #2196f3;\n  color: white;\n}\n\n.btn-edit:hover {\n  background: #1976d2;\n  transform: translateY(-1px);\n}\n\n.btn-save {\n  background: #4caf50;\n  color: white;\n}\n\n.btn-save:hover {\n  background: #388e3c;\n  transform: translateY(-1px);\n}\n\n.btn-delete {\n  background: #f44336;\n  color: white;\n}\n\n.btn-delete:hover {\n  background: #d32f2f;\n  transform: translateY(-1px);\n}\n\n.btn-cancel {\n  background: #757575;\n  color: white;\n}\n\n.btn-cancel:hover {\n  background: #616161;\n  transform: translateY(-1px);\n}\n\n/* ==================== CIRCULAR PROGRESS ==================== */\n.circular-progress {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.circular-progress text {\n  fill: #ffffff;\n  font-family: \"Segoe UI\", Arial, sans-serif;\n  font-weight: 600;\n}\n\n/* ==================== INPUTS ==================== */\n.machine-table input {\n  width: 90%;\n  padding: 6px 10px;\n  border: 1px solid #2c3e50;\n  border-radius: 4px;\n  background: #0d1b2a;\n  color: #ffffff;\n  font-size: 14px;\n}\n\n.machine-table input:focus {\n  outline: none;\n  border-color: #2196f3;\n  background: #15263a;\n}\n\n/* ==================== LOGIN ==================== */\n.login-container {\n  width: 360px;\n  margin: 100px auto;\n  padding: 40px;\n  background: #1a2332;\n  border-radius: 8px;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);\n}\n\n.login-container h2 {\n  margin: 0 0 30px 0;\n  font-size: 28px;\n  color: #ffffff;\n  text-align: center;\n  font-weight: 600;\n}\n\n.login-container input {\n  display: block;\n  width: 100%;\n  margin: 16px 0;\n  padding: 12px 16px;\n  font-size: 16px;\n  border-radius: 4px;\n  border: 1px solid #2c3e50;\n  background: #0d1b2a;\n  color: #ffffff;\n  box-sizing: border-box;\n}\n\n.login-container input:focus {\n  outline: none;\n  border-color: #2196f3;\n}\n\n.login-container input::placeholder {\n  color: #7a8a99;\n}\n\n.login-container button {\n  width: 100%;\n  padding: 12px 0;\n  font-size: 16px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  border-radius: 4px;\n  border: none;\n  background: #2196f3;\n  color: white;\n  cursor: pointer;\n  margin-top: 20px;\n  transition: all 0.2s;\n}\n\n.login-container button:hover {\n  background: #1976d2;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(33, 150, 243, 0.3);\n}\n\n/* ==================== LOADER ==================== */\n.loader-fullscreen {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #0a1929;\n  z-index: 9999;\n}\n\n.loader-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 40px;\n  background: #1a2332;\n  border-radius: 8px;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);\n}\n\n.neon-spinner {\n  width: 80px;\n  height: 80px;\n  border: 4px solid #2c3e50;\n  border-top: 4px solid #2196f3;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loader-text {\n  margin-top: 24px;\n  color: #ffffff;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n/* ==================== FILTER POPUP ==================== */\n.filter-popup {\n  position: absolute;\n  z-index: 2000;\n  background: #1a2332;\n  border: 1px solid #2c3e50;\n  border-radius: 4px;\n  padding: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.filter-popup input,\n.filter-popup select {\n  width: 220px;\n  padding: 8px 12px;\n  border-radius: 4px;\n  border: 1px solid #2c3e50;\n  background: #0d1b2a;\n  color: #ffffff;\n  font-size: 14px;\n  outline: none;\n}\n\n.filter-popup input:focus,\n.filter-popup select:focus {\n  border-color: #2196f3;\n}\n\n.filter-popup input::placeholder {\n  color: #7a8a99;\n}\n\n/* ==================== IP ADDRESS LIST ==================== */\n.ip-address-list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.ip-address-item {\n  display: flex;\n  gap: 8px;\n  font-size: 13px;\n}\n\n.interface-name {\n  color: #64b5f6;\n  font-weight: 600;\n  min-width: 80px;\n}\n\n.ip-value {\n  color: #ffffff;\n  font-family: 'Courier New', monospace;\n}\n\n.ip-address-list:has(.ip-address-item:only-child) {\n  flex-direction: row;\n}\n\n/* ==================== PORTS POPUP ==================== */\n.ports-popup-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 3000;\n  animation: fadeIn 0.2s ease-out;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.ports-popup {\n  background: #1a2332;\n  border-radius: 8px;\n  padding: 0;\n  max-width: 900px;\n  width: 90%;\n  max-height: 80vh;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n  animation: slideIn 0.3s ease-out;\n  display: flex;\n  flex-direction: column;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateY(-30px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.ports-popup-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #2c3e50;\n  background: #0d1b2a;\n  border-radius: 8px 8px 0 0;\n}\n\n.ports-popup-header h3 {\n  margin: 0;\n  font-size: 20px;\n  color: #ffffff;\n  font-weight: 600;\n}\n\n.close-btn {\n  background: transparent;\n  border: none;\n  color: #ffffff;\n  font-size: 28px;\n  width: 36px;\n  height: 36px;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n  line-height: 1;\n  padding: 0;\n}\n\n.close-btn:hover {\n  background: #f44336;\n  transform: scale(1.1);\n}\n\n.ports-loading,\n.no-ports {\n  text-align: center;\n  padding: 40px;\n  font-size: 16px;\n  color: #7a8a99;\n}\n\n.ports-table-wrapper {\n  overflow-y: auto;\n  max-height: calc(80vh - 80px);\n}\n\n.ports-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.ports-table thead {\n  position: sticky;\n  top: 0;\n  background: #0d1b2a;\n  z-index: 10;\n}\n\n.ports-table thead th {\n  padding: 14px 16px;\n  text-align: left;\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 2px solid #2c3e50;\n  border-right: 1px solid #2c3e50;\n}\n\n.ports-table thead th:last-child {\n  border-right: none;\n}\n\n.ports-table tbody tr {\n  background: #1a2332;\n  transition: background 0.2s;\n}\n\n.ports-table tbody tr:hover {\n  background: #243447;\n}\n\n.ports-table tbody td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #2c3e50;\n  border-right: 1px solid #2c3e50;\n  color: #ffffff;\n  font-size: 14px;\n}\n\n.ports-table tbody td:last-child {\n  border-right: none;\n}\n\n.port-number {\n  font-weight: 600;\n  color: #ffd700;\n  font-family: 'Courier New', monospace;\n}\n\n.process-name {\n  color: #4caf50;\n  font-weight: 500;\n}\n\n/* ==================== SCROLLBAR ==================== */\n.ports-table-wrapper::-webkit-scrollbar {\n  width: 10px;\n}\n\n.ports-table-wrapper::-webkit-scrollbar-track {\n  background: #0d1b2a;\n}\n\n.ports-table-wrapper::-webkit-scrollbar-thumb {\n  background: #2c3e50;\n  border-radius: 5px;\n}\n\n.ports-table-wrapper::-webkit-scrollbar-thumb:hover {\n  background: #3d5266;\n}\n\n/* ==================== DISK PROGRESS ==================== */\n.disk-progress-column {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.disk-progress-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.disk-progress-item span {\n  font-size: 12px;\n  min-width: 140px;\n}\n\n/* ==================== ACTION BUTTONS ==================== */\n.action-buttons {\n  white-space: nowrap;\n  padding: 8px 4px !important;\n}\n\n.action-buttons .btn {\n  display: block;\n  width: 100%;\n  margin: 4px 0;\n  padding: 8px 12px;\n  text-align: center;\n}\n\n/* ==================== RESPONSIVE ==================== */\n@media (max-width: 768px) {\n  .machine-table {\n    font-size: 12px;\n  }\n  \n  .machine-table thead th,\n  .machine-table tbody td {\n    padding: 10px 8px;\n  }\n  \n  .ports-popup {\n    width: 95%;\n  }\n  \n  .btn {\n    padding: 6px 10px;\n    font-size: 11px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
